import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { BProps, IRoles } from 'store/ducks/Reportings/types';
import { roleColumns } from 'constants/reportColumns';
import { ColumnsType } from 'antd/es/table';

const RiskSource: React.FC<BProps> = ({ entityName }) => {
  const { is_displayed, date } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<IRoles[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isDisplayed(false));

    if (!entityName) return;

    const entityIds = entityName.split(',').map((id) => id.trim());
    try {
      const fetchedData = await reportingOp.getRolesAndResponsibilities(
        entityIds[0],
        date,
      );
      if (fetchedData && fetchedData.roles) {
        const allEntities = Object.values(fetchedData.roles).flat();
        const formattedData: (IRoles & { _isFirstRow?: boolean })[] =
          allEntities.flatMap((role: any) => {
            const responsibilities = role.responsibilities || [];

            if (responsibilities.length === 0) {
              return [
                {
                  _isFirstRow: true,
                  entity_end_date: role.entity_end_date,
                  entity_id: role.entity_id,
                  entity_name: role.entity_name,
                  entity_reporting_date: role.entity_reporting_date,
                  entity_start_date: role.entity_start_date,

                  role_name: role.role_name,
                  role_description: role.role_description,
                  role_type: role.role_type,

                  responsibility_name: '',
                  responsibility_description: '',
                  responsibility_start_date: '',
                  responsibility_end_date: '',
                },
              ];
            }

            return responsibilities.map((resp: any, index: number) => ({
              _isFirstRow: index === 0,
              entity_end_date: role.entity_end_date,
              entity_id: role.entity_id,
              entity_name: role.entity_name,
              entity_reporting_date: role.entity_reporting_date,
              entity_start_date: role.entity_start_date,

              role_name: role.role_name,
              role_description: role.role_description,
              role_type: role.role_type,

              responsibility_name:
                resp.responsibility_name ?? resp.responsibility_id ?? '',
              responsibility_description: resp.responsibility_description ?? '',
              responsibility_start_date: resp.responsibility_start_date ?? '',
              responsibility_end_date: resp.responsibility_end_date ?? '',
            }));
          });

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error('Error fetching roles and responsibilities:', error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [is_displayed, entityName]);

  return (
    <Table
      columns={roleColumns as ColumnsType<(typeof data)[0]>}
      dataSource={data.map((item, idx) => ({ ...item, key: idx }))}
      pagination={false}
      scroll={{ x: 1000, y: 430 }}
    />
  );
};

export default RiskSource;
